import React, { useState, useEffect, useCallback } from 'react';

const API_BASE =
  process.env.REACT_APP_API_URL ||
  (typeof window !== 'undefined' && window.location.hostname === 'localhost'
    ? 'http://localhost:5001'
    : (typeof window !== 'undefined' ? window.location.origin : ''));

// Wallet / bonus / loyalty widget shown on the player's profile.
const LoyaltyWallet = ({ authToken }) => {
  const [data, setData] = useState(null);
  const [amount, setAmount] = useState('');
  const [moving, setMoving] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');

  const headers = { Authorization: `Bearer ${authToken}` };

  const fetchSummary = useCallback(async () => {
    try {
      const res = await fetch(`${API_BASE}/api/promotions/my-bonuses`, { headers });
      const json = await res.json();
      if (json.success) setData(json);
    } catch (e) { /* ignore */ }
  }, [authToken]);

  useEffect(() => { fetchSummary(); }, [fetchSummary]);

  const handleMove = async () => {
    setError('');
    setMessage('');
    setMoving(true);
    try {
      const res = await fetch(`${API_BASE}/api/promotions/move-loyalty`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...headers },
        body: JSON.stringify({ amount }),
      });
      const json = await res.json();
      if (json.success) {
        setMessage(json.message || 'Moved successfully');
        setAmount('');
        fetchSummary();
      } else setError(json.message || 'Failed to move');
    } catch (e) {
      setError(e.message);
    } finally {
      setMoving(false);
    }
  };

  const loyalty = data?.loyaltyBalance ?? 0;
  const activeBonus = data?.activeBonus;
  const upcoming = data?.upcomingBonuses || [];

  return (
    <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: '12px', padding: '16px', marginBottom: '16px' }}>
      <h3 style={{ margin: '0 0 12px' }}>🎁 Bonuses & Loyalty</h3>

      <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', marginBottom: '12px' }}>
        <div style={{ flex: 1, minWidth: '160px', background: '#f8fafc', borderRadius: '8px', padding: '12px' }}>
          <div style={{ fontSize: '0.8rem', color: '#666' }}>Loyalty Points</div>
          <div style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>${loyalty.toFixed(2)}</div>
        </div>
        <div style={{ flex: 1, minWidth: '160px', background: '#f8fafc', borderRadius: '8px', padding: '12px' }}>
          <div style={{ fontSize: '0.8rem', color: '#666' }}>Active Bonus</div>
          <div style={{ fontSize: '1.4rem', fontWeight: 'bold' }}>
            {activeBonus ? `$${parseFloat(activeBonus.remaining).toFixed(2)}` : '$0.00'}
          </div>
        </div>
      </div>

      {activeBonus && (
        <div style={{ fontSize: '0.85rem', color: '#b45309', marginBottom: '12px' }}>
          Active bonus (${parseFloat(activeBonus.remaining).toFixed(2)} remaining) expires{' '}
          {activeBonus.expires_at ? new Date(activeBonus.expires_at).toLocaleDateString() : '—'}.
        </div>
      )}
      {upcoming.length > 0 && (
        <div style={{ fontSize: '0.8rem', color: '#666', marginBottom: '12px' }}>
          {upcoming.length} upcoming bonus(es) — next activates after the current one is used/expired.
        </div>
      )}

      <div style={{ display: 'flex', gap: '8px', alignItems: 'center' }}>
        <input
          type="number"
          min="2"
          step="1"
          value={amount}
          onChange={e => setAmount(e.target.value)}
          placeholder="Min $2 (whole)"
          style={{ padding: '8px', border: '1px solid #ccc', borderRadius: '6px', width: '150px' }}
        />
        <button
          onClick={handleMove}
          disabled={moving || !amount}
          style={{ padding: '8px 14px', border: 'none', borderRadius: '6px', background: '#4f46e5', color: '#fff', fontWeight: '600', cursor: 'pointer' }}
        >
          {moving ? 'Moving…' : 'Move loyalty to wallet'}
        </button>
      </div>
      {message && <div style={{ color: '#16a34a', marginTop: '8px', fontSize: '0.85rem' }}>{message}</div>}
      {error && <div style={{ color: '#dc2626', marginTop: '8px', fontSize: '0.85rem' }}>{error}</div>}
    </div>
  );
};

export default LoyaltyWallet;
